<template>
	<div>
		<c-dialog ref="dialog" :title="'【' + username + '】的收货地址'" width="1000" :button="selector" :cancel-button="false">
			<m-search @search="searchHandle">
				<c-form>
					<c-form-item type="input" label="收货人" name="receiving_name"></c-form-item>
					<c-form-item type="input" label="收货人电话" name="receiving_phone"></c-form-item>
				</c-form>
			</m-search>
			
			<m-operate>
				<c-button power="b_platform_user_receive_address_edit" icon="add"  color="sys" @click="editHandle()">新增</c-button>
			</m-operate>
			
			<c-table ref="list" height="400" :paging="false">
				<c-table-column
					v-if="selector"
					type="selector"
					:multiple="false"
				></c-table-column>
				
				<c-table-column
					label="收货人"
					name="receiving_name"
					width="140"
				>
					<template v-slot="{data}">
						{{data.receiving_name+ '【'+data.receiving_phone+'】'}}
					</template>
				</c-table-column>
			
				<c-table-column
					label="收货地址"
					name="all_address_details"
					width="180"
				>
                    <template v-slot="{data}">
                        {{data.province_name}}
                        {{data.city_name}}
                        {{data.county_name}}
                        {{data.receiving_address_details}}
                    </template>
                </c-table-column>

				<c-table-column
					label="周末收货"
					name="is_weeked_receive"
					width="80"
				>
					<template v-slot="{data}">
						{{data.is_weeked_receive == "1" ? '是' : '否'}}
					</template>
				</c-table-column>
			
				<c-table-column
					label="预约电话"
					name="is_reservation"
					width="100"
				>
					<template v-slot="{data}">
						<span v-if="data.is_reservation == 1">{{data.reservation_tel}}</span>
						<span v-else>不需要预约</span>
					</template>
				</c-table-column>
			
				<c-table-column
					label="默认"
					name="is_default"
					width="50"
				>
					<template v-slot="{data}">
						<span v-if="data.is_default == 1">否</span>
						<span v-else>是</span>
					</template>
				</c-table-column>
			
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="190"
				>
					<template v-slot="{data}">
						<c-table-button power="b_platform_user_receive_address_edit" @click="editHandle(data)">编辑</c-table-button>
						<c-table-button power="b_platform_user_receive_address_edit" @click="deleteHandle(data)">删除</c-table-button>
						<c-table-button power="b_platform_user_receive_address_edit" v-if="data.is_default == 1"  @click="defaultHandle(data)">设为默认</c-table-button>
					</template>
				</c-table-column>
			</c-table>

			<template v-if="selector" slot="button">
				<c-button size="m" @click="resolveHandle">确定</c-button>
			</template>
		</c-dialog>

		<c-dialog ref="edit" :title="editFlag ? '编辑收货地址':'新增收货地址'" width="550" height="500" @resolve="editSubmit">
			<c-form ref="editForm">
				<c-form-item type="hidden" name="id"></c-form-item>
				<c-form-item  type="radio" label="周末是否收货" name="is_weeked_receive" :options="weekendOptions" required></c-form-item>
				<c-form-item  type="radio" v-model="currentBooking" label="预约与否" name="is_reservation" :options="bookingOptions" required></c-form-item>
				<c-form-item type="input" v-show="currentBooking == 1" label="预约电话" name="reservation_tel" required></c-form-item>
				<c-form-item type="region" label="收货地址" province-name="company_address_province" city-name="company_address_city" county-name="company_address_county" address-name="company_address_deails" required></c-form-item>
				<c-form-item type="input"  label="收货人" name="receiving_name" required></c-form-item>
				<c-form-item type="input"  label="收货电话" name="receiving_phone" required></c-form-item>
				<c-form-item type="checkbox" name="is_default"  :options="defaultType"></c-form-item>
			</c-form>
		</c-dialog>
	</div>
</template>

<script>
	export default {
		props: {
			selector: Boolean
		},
		
		data() {
			return {
				username: '',
				userId: '',
				weekendOptions: [
                    {name: '是',value: '1'},
                    {name: '否',value: '0'}
				],
                bookingOptions: [
                    {name: '需要',value: '1'},
                    {name: '不需要',value: '0'}
				],
				currentBooking: '',
				defaultType: [
                        {name: '设为默认',value: '2'}
                ],
				editFlag: false
			}
		},

		methods: {
			open(data) {
				this.username = data.nick_name;
				this.userId = data.platform_user_id;
				this.$refs.dialog.open();
				this.searchHandle();
			},

			searchHandle(data = {}) {
				this.$refs.list.load({
					url: '/member_user/address/list',
					data : Object.assign(data, {
						platform_user_id: this.userId
					})
				});
			},

			editHandle(data) {
				this.editFlag = !!data;
				this.$refs.editForm.clear();
				this.$refs.edit.open();
				
				if (data) {
					this.request({
						url: '/member_user/address/detail',
						data: {
							id: data.id
						},
						loading: true,
						success: data => {
						    data.is_default = [data.is_default];
							this.$refs.editForm.set(data);
						}
					});
				}
			},

			editSubmit(stop) {
				stop();
				this.$refs.editForm.submit({
					url: this.editFlag ? '/user_address/edit':'/user_address/add',
					rule: {
                        is_weeked_receive: '请选择周末是否收货',
						is_reservation: '请选择预约与否',
						reservation_tel:[{
							type:'function',
							fun:(value,data) =>{
								return !!value || this.isReservationVal != 1;
							},
							word: '请填写预约电话'
						}],
						company_address_province: '请填写收货地址',
                        company_address_city: '请填写收货地址',
                        company_address_county: '请填写收货地址',
						company_address_deails: '请填写详细地址',
						receiving_name: '请填写收货人',
						receiving_phone: '请填写收货电话',
					},
					dataFormatter: data => {
						data.user_id = this.userId;
						data.is_default = data.is_default.toString();
						return data;
					},
					success: (data, res) => {
						this.$message({
							text: this.editFlag ? '编辑成功':'添加成功'
						});
						this.$refs.list.update();
						this.$refs.edit.close();
					}
				});
			},

			deleteHandle(data) {
				this.$confirm({
					text: '确定要删除此地址吗？',
					resolve: () => {
						this.request({
							url: '/user_address/del',
							data: {
								id: data.id,
							},
							loading: true,
							success: data => {
								this.$message({
									text: '操作成功',
									icon: 'success'
								});
								this.$refs.list.update();
							}
						});
					}
				});
			},

			defaultHandle(data) {
				this.$confirm({
					text: '确定将此地址设为默认地址吗？',
					resolve: () => {
						this.request({
							url: '/user_address/edit_state',
							data: {
								id: data.id,
							},
							loading: true,
							success: data => {
								this.$message({
									text: '操作成功',
									icon: 'success'
								});
								this.$refs.list.update();
							}
						});
					}
				});
			},
			
			resolveHandle() {
				let row = this.$refs.list.getRow('selected')[0];
				if (!row) {
					this.$message({
						text: '请选择地址'
					});
					return;
				}
				this.$emit('resolve', row.data);
				this.$refs.dialog.close();
			}
		}
	}
</script>